import { Injectable } from '@angular/core';
import { EquipmentLogMapped } from '@core/interfaces';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class UpdatedByLogService {
  private readonly customAuthorDeviceMapper = Object.freeze({
    mountdoom: 'laptop',
    lorgan: 'upload',
    gorgoroth: 'smartphone',
    system: 'settings',
  });

  constructor(private translateService: TranslateService) { }

  public customUpdatedByInLogs(logs: EquipmentLogMapped[]): EquipmentLogMapped[] {
    for (let log of logs) {
      log = this.generateUpdateByLog(log);
    }

    return logs;
  }

  private generateUpdateByLog(log: EquipmentLogMapped): EquipmentLogMapped {
    const logCustomAuthor = {
      type: this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.AUTHOR.UPDATED'),
      updatedByName: null,
      clientApplicationName: null,
    };

    if (log.isEquipmentCreatedLog) {
      logCustomAuthor.type = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.AUTHOR.CREATED');
    }

    if (log.updatedBy && log.updatedBy.name) {
      logCustomAuthor.updatedByName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.AUTHOR.BY_AUTHOR', {
        authorName: log.updatedBy.name
      });
    }

    if (!log.clientApplicationName) {
      log.clientApplicationName = 'mountdoom';
    }

    logCustomAuthor.clientApplicationName = this.translateService.instant(`EQUIPMENTS.DIALOG.HISTORIC.AUTHOR.DEVICES.${log.clientApplicationName.toUpperCase()}`);
    if (Object.values(logCustomAuthor).filter(Boolean).length >= 2) {
      log.customAuthorDevice = this.customAuthorDeviceMapper[log.clientApplicationName.toLowerCase()];
      log.customAuthor = Object.values(logCustomAuthor).filter(Boolean).join(' ');
    }

    if (log.approval && log.approvedStatus === 'pending') {
      log.customAuthor = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.APPROVALS.AUTHOR_CREATED', {
        company: log.approval.company.name
      });
      log.customAuthorDevice = 'settings';
    }

    return log;
  }
}
